:root {
  scrollbar-color: var(--mantine-color-dark-5) transparent;
  scrollbar-width: thin;
}

.chat-container {
  width: 100%;
  height: 100%;
  padding: var(--mantine-spacing-md);
  contain: size;
  container-type: size;
}

.chat {
  position: relative;
  display: grid;
  grid-template: 'content sidebar' 1fr / 1fr auto;
  anchor-scope: all;
  anchor-name: --thread;
  height: 100cqh;
  overflow: hidden;
}
